jQuery(document).ready(function($) {
    $('.event-attendee-item.first-attendee').click(function(evt) {
        $(this).parents('.event-attendee-list').toggleClass('open');
    });

    if ($('.event-attendee-list').length > 0) {
        $('.event-attendee-list').each(function( key, value ) {
            var count = $(this).children().length;
            $(this).find('.attendee-count-value').first().text(count);
        });
    }
});